import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';

/**
 * Switches the active entity for the current session.
 * After success, every cached query is invalidated so each page re-fetches
 * data scoped to the new entity.
 */
export function useSwitchEntity() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (entitySlugOrId) =>
      api.post('/session/active-entity', { entity: entitySlugOrId }),
    onSuccess: () => {
      qc.invalidateQueries();
    },
  });
}
